import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Text } from '@modusign/design-system';

export default function ViewModeInlineAlert() {
  return (
    <Flex
      alignItems="center"
      bg="statusBackgroundNeutralDarkest"
      borderRadius="3px"
      bottom="96px"
      boxShadow="0px 10px 20px rgba(0, 0, 0, 0.25)"
      left="calc(50% - 180px)"
      position="fixed"
      px={6}
      py={5}
      width="xxs"
    >
      <FontAwesomeIcon color="#F33737" icon={faCircleExclamation} />
      <Text color="textNeutralLightest" ml={1} textAlign="left">
        내용 확인 화면에서는 변경사항을 저장할 수 없습니다.
      </Text>
    </Flex>
  );
}
